let link = "https://pos.globalsparks.live/api/";
let paylink = "https://pos.globalsparks.live/api/";

const apilink = {
  link,
  paylink,
};

export default apilink;
